import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button, Icon, Text } from '@src/components/base'
import { useLazyScreenPreload } from '@src/navigation/utils'

export const ScheduleNextCallButton = () => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()
  useLazyScreenPreload('ScheduleNextCallModal')

  const onPress = () => navigation.navigate('ScheduleNextCallModal')

  return (
    <View style={styles.card}>
      <Icon name="calendar-plus" size={24} weight="bold" style={styles.icon} />
      <View style={styles.content}>
        <Text type="regular" lineSpacing="none" bold>
          Book a Video Call
        </Text>
        <Text type="regular" lineSpacing="tight" style={styles.subtitle}>
          Choose a time that works for you.
        </Text>
      </View>
      <Button type="primary" size="small" accessibilityLabel="Book a Video Call" onPress={onPress}>
        Schedule
      </Button>
    </View>
  )
}

const themedStyles = StyleService.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    borderRadius: 16,
    borderWidth: 2,
    borderColor: 'theme.surface.base1',
    marginTop: 8,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  icon: {
    flexShrink: 0,
  },
  content: {
    gap: 4,
    flexGrow: 1,
    flexShrink: 1,
  },
  subtitle: {
    color: 'theme.text.secondary',
  },
  accessory: {
    flexShrink: 0,
  },
})
